import { Avatar, Box, Divider, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DUMMY from "../../Assets/User.webp";
import Fire from "../../Assets/fire.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import moment from "moment/moment";
import Loader from "../../Components/Loader";
const UserDetails = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const user_id = location?.state?.id;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const getUserDetails = async (params) => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post(ApiList.USER_GET, params);
      if (response?.data?.s === 1) {
        setData(response?.data?.r);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const fetchUserList = () => {
    if (!user_id) {
      console.error("User ID is not defined");
      return;
    }

    const params = {
      select: `u.*,ua.apikey,ua.token,(select count(id) from feed where user_id = ${user_id} and status = 1) AS feed_count`,
      from: "users u JOIN user_auth ua ON u.id = ua.user_id LEFT JOIN feed AS f ON f.user_id = u.id",
      childEntity: `{"dog_details":{"select":"ud.*, db.name AS breed_name, COALESCE((SELECT SUM(dwa.distance) FROM dog_walk_activity dwa WHERE FIND_IN_SET(ud.id, dwa.user_dogs_id) > 0 AND dwa.user_id = ud.user_id), 0) AS mileage","from":"user_dogs AS ud JOIN dog_breed AS db ON db.id = ud.breed_id","arg":"ud.user_id = ? AND ud.status = 1","prms":[":;id"]}}`,
      arg: `u.id=${user_id}`,
      order: "u.id DESC",
      limit: 1,
    };

    getUserDetails(params);
  };
  useEffect(() => {
    fetchUserList();
  }, []);
  console.log(data);
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#B9CC0310",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: "100%",
            p: 2,
            background: "#B9CC0310",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <IconButton onClick={() => navigation(-1)}>
            <ArrowBackIcon sx={{ color: "#000", fontSize: "28px" }} />
          </IconButton>
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "28px" },
              fontWeight: "300",
              color: "#000",
            }}
          >
            User Profile
          </Typography>
        </Box>
        {loading ? (
          <Loader />
        ) : (
          <Box
            sx={{
              width: "100%",
              p: 1,
              height: "calc(100vh - 76px)",
              overflow: "scroll",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                background: "#fff",
                borderRadius: "10px",
                p: 2,
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Box>
                <Avatar sx={{ width: "100px", height: "100px" }}>
                  <img
                    src={data?.image ? `${ApiList.IMG_URL}${data?.image}` : DUMMY}
                    style={{ width: "100%", height: "100%" }}
                  ></img>{" "}
                </Avatar>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  borderRadius: "10px",
                  background: "#dee884ff",
                  p: 2,
                  gap: "50px",
                }}
              >
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
                >
                  <Box>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "300",
                      }}
                    >
                      User Name
                    </Typography>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {data?.username}
                    </Typography>
                  </Box>
                  <Divider sx={{ borderColor: "#000" }} />
                  <Box>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "300",
                      }}
                    >
                      Name
                    </Typography>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {`${data?.fname} ${data?.lname}`}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
                >
                  <Box>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "300",
                      }}
                    >
                      Email
                    </Typography>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {data?.email}
                    </Typography>
                  </Box>
                  <Divider sx={{ borderColor: "#000" }} />
                  <Box>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "300",
                      }}
                    >
                      Streaks
                    </Typography>
                    <Box
                      sx={{
                        background: "#B9CC03",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        p: 0.8,
                        gap: "10px",
                      }}
                    >
                      <img
                        src={Fire}
                        style={{ width: "20px", height: "20px" }}
                      ></img>
                      <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                        {data?.streak_count}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "start",
                flexWrap: "wrap",
                gap: "16px",
              }}
            >
              {data?.dog_details?.map((item, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      width: "250px",
                      background: "#dee884",
                      borderRadius: "10px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 1,
                      }}
                    >
                      <Avatar sx={{ width: "60px", height: "60px" }}>
                        <img
                          src={item?.image ? `${ApiList.IMG_URL}${item?.image}` : DUMMY}
                          style={{ width: "100%", height: "100%" }}
                        ></img>{" "}
                      </Avatar>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        p: 2,
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <Typography>
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          Name :
                        </span>{" "}
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          {item?.name}
                        </span>
                      </Typography>
                      <Typography>
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          Birth Date :
                        </span>{" "}
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          {moment(item?.birth_date).format("DD/MM/YY")}
                        </span>
                      </Typography>
                      <Typography>
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          Breed :
                        </span>{" "}
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          {item?.breed_name}
                        </span>
                      </Typography>
                      <Typography>
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          Weight :
                        </span>{" "}
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          {`${item?.weight} kg`}
                        </span>
                      </Typography>
                      <Typography>
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          Gender :
                        </span>{" "}
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          {item?.gender === 1 ? "Male" : "Female"}
                        </span>
                      </Typography>
                      <Typography>
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          Mileage :
                        </span>{" "}
                        <span style={{ color: "#000", fontSize: "14px" }}>
                          {`${item?.mileage} mi`}
                        </span>
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default UserDetails;
